import TableToolbarPagination from './TableToolbarPagination'

export default TableToolbarPagination
